// import Vue from 'vue'
import { create } from 'axios'
import server from './server'

export const defaultHeaders = {}
const axios = create({ timeout: 30000 })
axios.interceptors.response.use(
  response => { response.ok = true; return response },
  err => {
    if (err.response) {
      err.response.ok = false
      return err.response
    }
    return Promise.reject(err.message)
  }
)
const api = { env: process.env.NODE_ENV }

api.asyncRequest = async (url, type, payload = {}) => {
  url = url.startsWith('/') ? server.backendUrl + url : url
  return axios({
    url,
    method: type,
    data: payload,
    headers: defaultHeaders
  })
}

api.sendHeaders = (headerName, value) => {
  if (value) defaultHeaders[headerName.toLowerCase()] = value
}

api.removeHeaders = headerName => {
  delete defaultHeaders[headerName.toLowerCase()]
}

api.isPanoramaCubemapReady = async (panoramaId = '', filename = '') => {
  try {
    const IS_PANORAMA_CUBEMAP_URL = `${server.backendUrl}/v2/panoramas/${panoramaId}/cubemapReady?fileName=${filename}`
    const resp = await axios.get(IS_PANORAMA_CUBEMAP_URL)
    if (resp.status === 200 && resp.data) {
      return resp.data.cubeMapReady
    } else {
      return false
    }
  } catch (e) {
    return false
  }
}

export const initGoogleAPI = () => {
  if (process.env.USE_GOOGLE_MAP) {
    return new Promise((resolve) => {
      if (document.getElementById('gmap')) {
        return
      }
      const js = document.createElement('script')
      js.id = 'gmap'
      js.src = `https://maps.googleapis.com/maps/api/js?key=${server.googleApiKey}&libraries=places`
      js.onload = () => resolve()
      const fjs = document.getElementsByTagName('script')[0]
      fjs.parentNode.insertBefore(js, fjs)
    })
  }
}

export default api
